import React from 'react';

import bubbles from '../../assets/animations/bubbles-bw.png';
import dots from '../../assets/animations/dots-bw.png';
import fireworks from '../../assets/animations/fireworks-bw.png';
import lines from '../../assets/animations/lines-bw.png';
import spotlight from '../../assets/animations/spotlight-bw.png';

import { TAppElkBackgroundAnimation } from 'TProtocol/prototypes/events/messages';
import styled from 'styled-components';

interface Props {
  animation: TAppElkBackgroundAnimation;
  selected: boolean;
  onSelect: (animation: TAppElkBackgroundAnimation) => void;
}

const AnimationOption = ({ animation, selected, onSelect }: Props) => {
  let image = spotlight;

  switch (animation) {
    case undefined:
      break;
    case TAppElkBackgroundAnimation.BLURRED_LINES:
      image = lines;
      break;
    case TAppElkBackgroundAnimation.BLURRY_BUBBLES:
      image = dots;
      break;
    case TAppElkBackgroundAnimation.CHAMPAGNE_BUBBLES:
      image = bubbles;
      break;
    case TAppElkBackgroundAnimation.COSMIC:
      // TODO: this one isn't done yet, the example was way too complicated
      break;
    case TAppElkBackgroundAnimation.FIREWORKS:
      image = fireworks;
      break;
    case TAppElkBackgroundAnimation.LIGHT_SOURCE:
      break;
    case TAppElkBackgroundAnimation.OIL_ON_WATER:
      // TODO: this one isn't done yet, we need to generate the image somehow
      break;
    default:
      const exhaustiveCheck: never = animation;
      throw new Error(`Unhandled field type: ${exhaustiveCheck}`);
  }

  const onClick = () => {
    if (!selected) {
      onSelect(animation);
    }
  }

  return <AnimationBox $selected={selected} src={image} onClick={onClick}/>;
};

const AnimationBox = styled.img<{ $selected: boolean }>`
  width: 60px;
  height: 60px;
  border-radius: 6px;
  border: ${({ $selected }) => $selected ? 5 : 2}px solid #fff;
  margin: ${({ $selected }) => $selected ? 7 : 10}px;
`;

export default AnimationOption;
